/* Woodmobiel — VIP upgrade (globaal) */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Reveal-on-scroll ---------- */
  var REVEAL = [
    '.wm-eyebrow','.wm-h2','.wmg__grouptitle',
    '.wmp__card','.wmg__card','.wm-ws__card','.wm-insp__tile','.wm-over__card','.wmw__card',
    '.wmau__i','.wmfaq__item','.wm-prod-specs__row','.wm-prod-why__card',
    '.wmsl__head','.wmrv__head','.wmg__head','.wmab__vhead','.wmab__vframe','.wmab__opa',
    '.wm-museums__inner','.wm-bc__inner','.wm-today__tile','.wm-reviews__card','.wm-blogs__card','.wm-opaben__inner','.wm-cta__inner'
  ].join(',');
  function setupReveal(){
    if(reduce) return;
    if(!('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll(REVEAL));
    // stagger cards that share a parent
    var byParent = new Map();
    els.forEach(function(el){
      if(el.closest('.wmsl__track') || el.closest('.wmrv__track')) return; // skip auto-sliders
      el.classList.add('wm-reveal');
      var p = el.parentNode;
      var i = byParent.get(p) || 0; byParent.set(p, i+1);
      el.style.transitionDelay = Math.min(i*70, 420) + 'ms';
    });
    /* Secties laten op- en wegvervagen bij het scrollen (Loom: "dat het zo mooi
       vervaagt"). Geldt op ELKE pagina en voor ELKE sectie, behalve de vaste
       onderdelen: header, footer, hero en de sticky koopbalk. */
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), function(sec){
      if(sec.querySelector('.wm-hero, .header-wrapper, .wm-satc')) return;
      if(sec.querySelector('.wm-footer, footer')) return;
      /* Secties met een pop-up NIET laten vervagen: de transform/will-change maakt
         een nieuw referentiekader, waardoor een position:fixed modal niet meer over
         het scherm valt maar binnen de sectie wordt uitgerekt. */
      if(sec.querySelector('.wmg-modal, [data-wm-modal], dialog, .wm-modal')) return;
      // eerste ZICHTBARE kind pakken; <style>/<script>/<link> tellen niet mee
      var inner = null;
      for(var i=0; i<sec.children.length; i++){
        var t = sec.children[i].tagName;
        if(t!=='STYLE' && t!=='SCRIPT' && t!=='LINK' && t!=='NOSCRIPT'){ inner = sec.children[i]; break; }
      }
      if(!inner) return;
      // zit er al een element-animatie op? dan die met rust laten en de sectie zelf pakken
      if(inner.classList.contains('wm-reveal')) inner = sec;

      /* Pagina's als /producten en /voorbeelden zijn één groot blok. Eén fade over
         de hele pagina voelt nergens naar, dus pakken we daar de losse blokken
         binnenin. */
      var vh = window.innerHeight || 800;
      if(inner.getBoundingClientRect().height > vh * 1.6){
        var kinderen = inner.querySelectorAll(':scope > section, :scope > div, :scope > article');
        var geplaatst = 0;
        Array.prototype.forEach.call(kinderen, function(k){
          if(k.getBoundingClientRect().height < 120) return;      // te klein om te laten vervagen
          if(k.classList.contains('wm-reveal')) return;
          k.classList.add('wm-sec-reveal'); geplaatst++;
        });
        if(geplaatst) return;                                     // klaar, sectie zelf niet ook nog
      }
      inner.classList.add('wm-sec-reveal');
    });

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('wm-in'); io.unobserve(e.target); } });
    }, { threshold:0.08, rootMargin:'0px 0px -6% 0px' });
    document.querySelectorAll('.wm-reveal, .wm-sec-reveal').forEach(function(el){ io.observe(el); });
  }

  /* ---------- 2. Count-up cijfers ---------- */
  function countUp(el){
    var target = parseFloat(el.getAttribute('data-wm-count'));
    var suffix = el.getAttribute('data-wm-suffix') || '';
    var dur = 1400, start = null;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      var eased = 1 - Math.pow(1-p, 3);
      var val = Math.floor(eased * target);
      el.textContent = val.toLocaleString('nl-NL') + suffix;
      if(p < 1){ requestAnimationFrame(step); } else { el.textContent = target.toLocaleString('nl-NL') + suffix; el.setAttribute('data-wm-counted','1'); }
    }
    requestAnimationFrame(step);
  }
  function setupCounts(){
    var els = document.querySelectorAll('[data-wm-count]');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(countUp); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ countUp(e.target); io.unobserve(e.target); } });
    }, { threshold:0.6 });
    els.forEach(function(el){ io.observe(el); });
  }

  /* ---------- 3. Magnetische knoppen ---------- */
  function setupMagnetic(){
    if(reduce || !window.matchMedia('(hover: hover)').matches) return;
    var sel = '.wm-btn--primary, .wmp__cta, .product-form__submit, .wm-modal__cta, .wm-satc__btn, .wmau, .wm-cta a';
    document.querySelectorAll('.wm-btn--primary, .wmp__cta, .product-form__submit, .wm-modal__cta, .wm-satc__btn').forEach(function(btn){
      btn.classList.add('wm-magnetic');
      btn.addEventListener('mousemove', function(e){
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width/2;
        var y = e.clientY - r.top - r.height/2;
        btn.style.transform = 'translate(' + (x*0.28) + 'px,' + (y*0.32) + 'px)';
      });
      btn.addEventListener('mouseleave', function(){ btn.style.transform = ''; });
    });
  }

  /* ---------- 4. Houtblok vliegt naar de cart ---------- */
  function cartTarget(){
    return document.querySelector('#cart-icon-bubble')
        || document.querySelector('.header__icon--cart')
        || document.querySelector('.header__icons a[href*="/cart"]')
        || document.querySelector('a[href$="/cart"]')
        || document.querySelector('[id*="cart-icon"]');
  }
  function bounceCart(cart){
    if(cart && cart.animate){
      cart.animate([{transform:'scale(1)'},{transform:'scale(1.32)',offset:.3},{transform:'scale(.9)',offset:.6},{transform:'scale(1.06)',offset:.8},{transform:'scale(1)'}],{duration:560,easing:'ease'});
    }
  }
  function flyToCart(fromEl){
    var start = fromEl.getBoundingClientRect();
    var cart = cartTarget();
    var endX, endY;
    if(cart){ var e = cart.getBoundingClientRect(); endX = e.left + e.width/2; endY = e.top + e.height/2; }
    else { endX = window.innerWidth - 42; endY = 42; }
    var sx = start.left + start.width/2, sy = start.top + start.height/2;
    // Woodmobiel-logo als vliegend element — alles inline (geen CSS-afhankelijkheid)
    var block = document.createElement('img');
    block.src = 'https://cdn.shopify.com/s/files/1/0911/4294/7164/files/woodmobiel-logo-trim.png';
    block.alt = '';
    block.style.cssText = 'position:fixed;left:'+(sx-34)+'px;top:'+(sy-34)+'px;width:68px;height:auto;'+
      'z-index:2147483000;pointer-events:none;filter:drop-shadow(0 9px 20px rgba(0,0,0,.32));';
    document.body.appendChild(block);
    var dx = endX - sx, dy = endY - sy;
    if(block.animate){
      var a = block.animate([
        { transform:'translate(0,0) scale(.4)', opacity:0 },
        { transform:'translate(0,-18px) scale(1.2)', opacity:1, offset:0.16 },
        { transform:'translate('+dx+'px,'+dy+'px) scale(.25) rotate(240deg)', opacity:0.1 }
      ], { duration:1600, easing:'cubic-bezier(.5,-0.14,.6,1)', fill:'forwards' });
      a.onfinish = function(){ block.remove(); bounceCart(cart); };
    } else {
      setTimeout(function(){ block.remove(); bounceCart(cart); }, 1600);
    }
  }
  function setupCartFly(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest && e.target.closest('.product-form__submit, button[name="add"], .wm-satc__btn');
      if(btn && !btn.disabled){ flyToCart(btn); }
    }, true);
  }

  /* ---------- 5. Sticky mini-koopbalk ---------- */
  function setupSticky(){
    var bar = document.querySelector('.wm-satc'); if(!bar) return;
    var anchor = document.querySelector('.product-form__submit') || document.querySelector('product-form');
    if(!anchor){ return; }
    var realBtn = document.querySelector('.product-form__submit');
    var stickyBtn = bar.querySelector('.wm-satc__btn');
    if(stickyBtn && realBtn){
      stickyBtn.addEventListener('click', function(){
        var form = realBtn.closest('form');
        if(form && form.requestSubmit){ form.requestSubmit(realBtn); } else { realBtn.click(); }
      });
    }
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        // toon de balk wanneer de echte knop UIT beeld is (eronder gescrold)
        if(!e.isIntersecting && e.boundingClientRect.top < 0){ bar.classList.add('wm-satc--show'); }
        else { bar.classList.remove('wm-satc--show'); }
      });
    }, { threshold:0 });
    io.observe(anchor);
  }

  /* ---------- 6. Parallax hero ---------- */
  function setupParallax(){
    if(reduce) return;
    var img = document.querySelector('.wm-hero__img');
    if(!img) return;
    img.style.willChange = 'transform';
    function onS(){
      var y = window.scrollY || window.pageYOffset || 0;
      if(y < window.innerHeight * 1.25){ img.style.transform = 'translate3d(0,' + (y*0.22).toFixed(1) + 'px,0) scale(1.14)'; }
    }
    window.addEventListener('scroll', onS, { passive:true });
    onS();
  }

  /* ---------- 7. Subtiele houten-bolt cursor-volger (desktop) ---------- */
  function setupBoltCursor(){
    if(reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var dot = document.createElement('div'); dot.className = 'wm-bolt-cursor';
    document.body.appendChild(dot);
    var x=0,y=0,tx=0,ty=0,active=false;
    document.addEventListener('mousemove', function(e){ tx=e.clientX; ty=e.clientY; if(!active){ active=true; x=tx; y=ty; dot.style.opacity='.85'; } });
    document.addEventListener('mouseleave', function(){ dot.style.opacity='0'; });
    (function loop(){ x += (tx-x)*0.2; y += (ty-y)*0.2; dot.style.transform='translate('+(x-9)+'px,'+(y-9)+'px)'; requestAnimationFrame(loop); })();
  }

  function boot(){ try{ console.log('[WM-VIP] geladen (reduce-motion: ' + reduce + ')'); }catch(e){} setupReveal(); setupCounts(); setupMagnetic(); setupCartFly(); setupSticky(); setupParallax(); setupBoltCursor(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
